import React, { Fragment, useEffect, useState } from 'react';
import { BsCaretLeftFill, BsCaretRightFill } from 'react-icons/bs';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { translate } from 'react-i18next';
import { isMobile } from 'react-device-detect';
import DatagridLoLe from '../../../table/DatagridLoLe';

function TblLole({ t, partSnap, typeIndex }) {
  const [heightTb, setHeightTb] = useState(360);

  useEffect(() => {
    const heightTb = 360 - (typeIndex === 1 ? 0 : typeIndex === 2 ? 100 : 145);
    setHeightTb(heightTb);
  }, [typeIndex]);

  return (
    <Fragment>
      <div className="tbl-fix-header">
        <DatagridLoLe resource={[]} className="table table-bordered table-fix">
          <tr>
            <th rowSpan="2">{t('txt-symbol')}</th>
            <th rowSpan="2" className="high-light">
              {t('txt-ref')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-ceil')}
            </th>
            <th rowSpan="2" className="high-light">
              {t('txt-floor')}
            </th>
            <th colSpan="6">{t('txt-bid')}</th>
            <th colSpan="3" className="high-light">
              {t('txt-match')}
            </th>
            <th colSpan="6">{t('txt-ask')}</th>
          </tr>
          <tr>
            <th>{t('txt-price')} 3</th>
            <th>{t('txt-vol')} 3</th>
            <th>{t('txt-price')} 2</th>
            <th>{t('txt-vol')} 2</th>
            <th>{t('txt-price')} 1</th>
            <th>{t('txt-vol')} 1</th>
            <th className="high-light">{t('txt-price')}</th>
            <th className="high-light">{t('txt-vol')}</th>
            <th className="high-light position-relative">{'+/-'}</th>
            <th>{t('txt-price')} 1</th>
            <th>{t('txt-vol')} 1</th>
            <th>{t('txt-price')} 2</th>
            <th>{t('txt-vol')} 2</th>
            <th>{t('txt-price')} 3</th>
            <th>{t('txt-vol')} 3</th>
          </tr>
        </DatagridLoLe>
      </div>
      {!isMobile && (
        <PerfectScrollbar style={{ height: `calc(100vh - ${heightTb}px)` }}>
          <DatagridLoLe
            resource={partSnap}
            className="table table-bordered table-fix"
          />
        </PerfectScrollbar>
      )}
      {isMobile && (
        <div
          style={{
            width: '100%',
            height: `calc(100vh - ${heightTb}px)`,
            overflowY: 'auto',
          }}
        >
          <DatagridLoLe
            resource={partSnap}
            className="table table-bordered table-fix"
          />
        </div>
      )}
    </Fragment>
  );
}

export default translate('translations')(TblLole);
